import React from 'react';
import {useStyles} from '../styles/HomeStyles';
import {inject, observer} from 'mobx-react';
import {closeSideWidth, openSideWidth} from '../../../stores/NavigateStore';
import SummaryContents from './SummaryContents';

function SummaryContentHome(props) {
    const classes = useStyles();
    const {sideBarOpen} = props.navigateStore;

    return (
        <div
            className={classes.root}
            style={sideBarOpen ? {width: `calc(100% - ${openSideWidth}px)`} : {width: `calc(100% - ${closeSideWidth}px)`}}
        >
            <SummaryContents/>
        </div>
    );
}

export default inject('contentStore','navigateStore')(observer(SummaryContentHome))
